import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import ApiList from "services/apiList";
import Card from "./components/card";
import "./style.scss";
import axios from "axios";

const FoodDetails = () => {
  const [food, setFood] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchFood = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          ApiList.getFoodListUrl + `${id}/`
        );
        setFood(response?.result);
      } catch (error) {
        alert("Сервертэй холбогдож чадсангүй");
      } finally {
        setLoading(false);
      }
    };

    fetchFood();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!food) {
    return <div>Хоол олдсонгүй</div>;
  }

  return (
    <Card title={food.name}>
      <table id="info">
        <tbody>
          <tr>
            <td className="title">Картыг баталсан:</td>
            <td className="subtitle">Оюунболд</td>
          </tr>
          <tr>
            <td className="title">Бичилт хийсэн:</td>
            <td className="subtitle">Оюунболд</td>
          </tr>
          <tr>
            <td className="title">Бүтээгдэхүүний нэр:</td>
            <td className="subtitle">{food.name}</td>
          </tr>
          <tr>
            <td className="title">Огноо:</td>
            <td className="subtitle">2024-09-30</td>
          </tr>
        </tbody>
      </table>

      {/* Orts EBS */}
      {food.type === 1 && renderOrts(food)}
      {/* Orts SUB */}
      {food.type === 2 && renderOrtsKg(food)}

      {/* Texnolgy card */}
      <div className="flex flex-wrap justify-between gap-3">
        <div className="tech-card">
          <div className="title">Технологи ажиллагаа</div>
          <div className="description">{food.technology}</div>
        </div>

        {/* Шинж байдал */}
        <div className="tech-card">
          <div className="title">Шинж байдал</div>
          <div className="description">
            {food.image && (
              <img
                src={`${ApiList.baseMediaUrl}${food.image}`}
                alt="Хоолны зураг"
                className="max-w-[350px]"
              />
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

const renderOrtsKg = (food) => {
  const renderItems = (type) => {
    let ports = food.ports1;

    if (type === 2) {
      ports = food.ports2;
    }

    return (
      <div>
        {ports.map((p, i) => {
          return (
            <table id="orts" key={i} className="mb-2">
              <thead>
                <tr>
                  <th rowSpan={2}>Д/д</th>
                  <th rowSpan={2} className="!text-left">
                    Хүнсний материалын нэрс
                  </th>
                  <th colSpan={7}>Нэгжийн нэр /гр/</th>
                </tr>
                <tr>
                  <th>Бохир</th>
                  <th>Цэвэр</th>
                  <th>Уураг</th>
                  <th>Өөх тос</th>
                  <th>Нүүрс ус</th>
                  <th>Илчлэг</th>
                  <th>Гарц</th>
                </tr>
              </thead>
              <tbody>
                {p.orts.map((item, index) => {
                  return (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td className="!text-left">{item.items}</td>
                      <td>
                        {item.bokhir}
                        {item.unit}
                      </td>
                      <td>
                        {item.tsewer}
                        {item.unit}
                      </td>

                      <td>{p.protein}</td>
                      <td>{p.fat}</td>
                      <td>{p.carbohydrates}</td>
                      <td>{p.calorie}</td>
                      <td>{p.result}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        })}
      </div>
    );
  };

  return (
    <Tabs defaultIndex={0} className="w-full" variant="line" size="sm">
      <TabList>
        <Tab>2-3 нас</Tab>
        <Tab>4-5 нас</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>{renderItems(1)}</TabPanel>
        <TabPanel>{renderItems(2)}</TabPanel>
      </TabPanels>
    </Tabs>
  );
};

const renderOrts = (food) => {
  return (
    <table id="orts">
      <thead>
        <tr>
          <th rowSpan={2}>Д/д</th>
          <th rowSpan={2} className="!text-left">
            Хүнсний материалын нэрс
          </th>
          <th colSpan={7}>Нэгжийн нэр /гр/</th>
        </tr>
        <tr>
          <th>Бохир</th>
          <th>Цэвэр</th>
          <th>Уураг</th>
          <th>Өөх тос</th>
          <th>Нүүрс ус</th>
          <th>Илчлэг</th>
          <th>Гарц</th>
        </tr>
      </thead>
      <tbody>
        {food.items.map((item, index) => {
          return (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td className="!text-left">{item.items}</td>
              <td>
                {item.bokhir}
                {item.unit}
              </td>
              <td>
                {item.tsewer}
                {item.unit}
              </td>

              <td>{food.protein}</td>
              <td>{food.fat}</td>
              <td>{food.carbohydrates}</td>
              <td>{food.calorie}</td>
              <td>{food.result}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default FoodDetails;
